import { ProgressSpinner } from 'callahan-react'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Route, Switch } from 'react-router-dom'

import AdminPanel from '../AdminPanel/AdminPanel'
import { loadProtectedPage } from '../../actions/protected-page-actions'
import { PageConstants } from '../../constants/page-constants'
import { ADMIN_BASE_URL } from '../../constants/route-constants'
import { getProtectedPageRedirect } from '../../utils/url-utils'

import './protected-page.css'

const propTypes = {
  loadProtectedPageError: PropTypes.bool,
  loadProtectedPageStatus: PropTypes.number,
  loadProtectedPageInProgress: PropTypes.bool
}

export class ProtectedPage extends Component {
  componentDidMount() {
    this.props.dispatch(loadProtectedPage())
  }

  render() {
    const pageRoutes = PageConstants.map(page => (
      <Route
        key={page.url}
        exact={true}
        path={`${ADMIN_BASE_URL}${page.url}`}
        component={page.component}
      />
    ))

    if (this.props.loadProtectedPageError) {
      window.location = getProtectedPageRedirect()
      return <div />
    }

    if (this.props.loadProtectedPageInProgress) {
      return (
        <div>
          <ProgressSpinner className="protected-spinner" size={'large'} />
        </div>
      )
    }
    return (
      <div>
        <Switch>
          {pageRoutes}
          <Route exact path={ADMIN_BASE_URL} component={AdminPanel} />
        </Switch>
      </div>
    )
  }
}

ProtectedPage.propTypes = propTypes

function mapStateToProps(state) {
  const { protectedPage } = state
  return {
    loadProtectedPageError: protectedPage.loadProtectedPageError,
    loadProtectedPageStatus: protectedPage.loadProtectedPageStatus,
    loadProtectedPageInProgress: protectedPage.loadProtectedPageInProgress
  }
}

export default connect(mapStateToProps)(ProtectedPage)



// WEBPACK FOOTER //
// ./src/pages/ProtectedPage/ProtectedPage.js